import { useCallback, useMemo } from 'react';

import { AxiosRequestConfig } from 'axios';
import useAPI from 'hooks/use-api';
import { API } from 'redux/api';

interface AllClassAverageAttendanceResponse extends MessageResponse {
  classData: ClassAverageAttendance[];
}

export const useAllClassAttendanceData = (course: CourseAverageAttendance | null) => {
  const transformResponse = useCallback(
    (response: AllClassAverageAttendanceResponse) => response.classData,
    []
  );
  const config = useMemo<AxiosRequestConfig>(
    () => ({
      url: API.ATTENDANCE_COURSE_ALL,
      params: { courseId: course?.courseId },
      transformResponse,
      headers: course
        ? {
            'X-parent-course-id': course.parentId,
            ...(course?.isChildCourse === 1
              ? {
                  'X-child-course-id': course.childCourseId,
                }
              : {}),
          }
        : undefined,
    }),
    [course, transformResponse]
  );
  return useAPI<ClassAverageAttendance[], MessageResponse>(config, Boolean(course?.courseId));
};
